import { axiosInstance, generateSourceToken, isCancelError } from 'sharedWebpack/httpClient';

const myAxios = axiosInstance('v3');

export default myAxios;

export { generateSourceToken, isCancelError };
